//请自行添加语言资源
const factory = {
  factoryNo:'工厂编码',
  factoryName:'工厂名称',
  createTime:"创建时间",
  creator:"创建用户",
  updateTime:"更新时间",
  updater:"更新用户",
  msg:{
  }
};
export default factory



// WEBPACK FOOTER //
// ./src/page/md/factory/lang/factory.zh.js